module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm0 15.968c-.008.484-.242.964-.732 1.33l-5.498 4.15C8.754 22.21 8 21.8 8 20.528v-9.22c0-1.276.754-1.688 1.77-.926l5.46 4.152c.492.37.746.852.77 1.34v.094zm10 0c-.008.482-.242.962-.732 1.33l-5.498 4.15c-1.016.762-1.77.352-1.77-.92v-9.22c0-1.276.754-1.688 1.77-.926l5.46 4.152c.492.37.746.852.77 1.34v.094z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/next-4.js
// module id = 1306
// module chunks = 14